import { ExerciseData } from '../../exercises';
import React from 'react';
import { Exercise } from '../../components';
import { Boundaries } from '../../../articles/Boundaries';

export const exerciseData43: ExerciseData = {
    ExerciseView: Module4Exercise3,
    dataKeys: [],
    questions: [],
};

function Module4Exercise3() {
    return (
        <Exercise title="Hvordan sætter du grænser?">
            <Boundaries />
        </Exercise>
    );
}
